module.exports = __webpack_public_path__ + "img/bg-concern.57295946.png";